"use client";
import { useState } from "react";
import renderSkeleton from "../common/renderSkeleton";

const PdfLoader = ({
  media,
  alt = "Pdf loader",
  pdfStyle,
  skeletonStyle,
  skeletonHeight,
  skeletonWidth,
  className = "",
}) => {
  const [pdfLoaded, setPdfLoaded] = useState(false);
  return (
    <>
      {!pdfLoaded &&
        renderSkeleton(skeletonHeight, skeletonWidth, skeletonStyle)}
      <iframe
        src={media.mediaUrl}
        className={className}
        title={media.mediaName}
        alt={alt}
        onLoad={() => setPdfLoaded(true)}
        style={{
          ...pdfStyle,
          display: pdfLoaded ? pdfStyle.display || "block" : "none",
          transition: "opacity 0.3s ease",
        }}
      />
    </>
  );
};

export default PdfLoader;
